import api from "services/api";

import { IBankData } from "../interfaces";

export const SubmitBankData = async (bankData: IBankData, bank_id: string) => {
  try {
    if(bank_id !== 'não pussuí'){
      await api.put(`/banks/${bank_id}`, bankData);

      return Promise.resolve()
    }

    await api.post('/banks', bankData)

    return Promise.resolve()
  } catch (error: any) {
    return Promise.reject(error?.response?.data?.message);
  }
}
